export const search = {
    namespaced: true,
    state: {
        stonetype: [],
        surface: [],
        colors: [],
    },
/*
    actions: {
        setStoneType({ commit }, query) {
            commit('stonetype', query);
        },
        error({ commit }, message) {
            commit('error', message);
        },
        clear({ commit }, message) {
            commit('success', message);
        }
    },
    mutations: {
        success(state, message) {
            state.stonetype = 'alert-success';
            state.message = message;
        },
        error(state, message) {
            state.type = 'alert-danger';
            state.message = message;
        },
        clear(state) {
            state.type = null;
            state.message = null;
        }
    }
*/
}